import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSu = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 72 80",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		fill: "#0D0E10",
		fillRule: "evenodd",
		children: [/* @__PURE__ */ _jsxs("g", {
			transform: "translate(2 26)",
			children: [
				/* @__PURE__ */ _jsx("path", { d: "M42-2v29h4.257l.061.221C47.29 30.576 50.368 33 54 33l.25-.004a8.004 8.004 0 007.454-5.831l.043-.165H63a3 3 0 003-3v-7.695a4 4 0 00-.182-1.193L61.348.807A4 4 0 0057.53-2H42zm15.53 2a2 2 0 011.909 1.403l4.47 14.306a2 2 0 01.091.596V24a1 1 0 01-1 1h-3a6 6 0 01-11.996.225L48 25h-4V0h13.53z" }),
				/* @__PURE__ */ _jsx("path", { d: "M48 0h2v13h-2zm-4 13h20v2H44z" }),
				/* @__PURE__ */ _jsx("circle", {
					cx: 54,
					cy: 26,
					r: 2
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 6,
					cy: 26,
					r: 2
				}),
				/* @__PURE__ */ _jsx("path", { d: "M44 19H-2v6l.004.262C-1.836 29.59 1.694 33 6 33l.25-.004a8.004 8.004 0 007.454-5.831l.043-.165H44v-8zm-2 2v4H12a6 6 0 01-11.996.225L0 25v-4h42z" })
			]
		}), /* @__PURE__ */ _jsx("path", { d: "M44 18v8h8.05l-.055-2.249C51.836 20.515 49.202 18 46 18h-2zm2 2a4 4 0 013.995 3.8L50 24h-4v-4zM9 41H7a3 3 0 00-3 3v3h8v-3a3 3 0 00-3-3zm0 2a1 1 0 011 1v1H6v-1a1 1 0 011-1h2z" })]
	})
});
export default SvgSu;
